export default {
  // Global
  global: {
    search: '検索',
    change: '変更',
    narrowDown: '絞り込む',
    add: '作成',
    edit: '編集',
    delete: '削除',
    confirm: '確定',
    cancel: 'キャンセル',
    quit: '戻る',
    all: '全て',
    true: 'はい',
    false: 'いいえ',
    controls: '操作',
    inputPlaceholder: 'を入力してください',
    selectPlaceholder: 'を選択してください',
    reset: 'リセット',
    allReset: '入力内容を全てリセット',
    addItems: 'アイテムを追加',
    createTime: '作成日時',
    updateTime: '更新日時',
    ASC: '昇順',
    DESC: '降順',
    export: '出力',
    success: '成功',
    user: 'ユーザー',
    password: 'パスワード',
    addSuccess: '追加しました',
    editSuccess: '更新しました',
    deleteSuccess: '削除しました',
    operationSuccess: '実行しました',
    clearSuccess: 'クリアしました',
    refreshCachListSucess: 'キャッシュリスト更新しました',
    refreshKeyListSuccess: 'キー名リスト更新しました',
    cleanCacheName: 'キャッシュをクリアしました',
    cleanCacheKeyName: 'キャッシュキーを削除しました',
    cleanAllCacheSuccess: '全キャッシュのクリア成功',
    unlockSuccess: 'ロック解除しました',
    cancelAccessSuccess: '認証を取り消しました',
    editPWSuccess: 'パスワード変更しました',
    genCustomPathSuccess: 'カスタムパスの生成が成功しました',
    personal: 'ユーザー設定',
    layoutSetting: 'レイアウト設定',
    logout: 'ログアウト',
    layoutSize: 'レイアウトサイズ',
    plsInput: 'を入力してください',
    plsSelect: 'を選択してください',
    confirmDelete: '削除をしますか',
    large: '大きめ',
    default: 'デフォルト',
    small: '小さめ',
    status: 'ステータス',
    operation: '操作',
    collapse: '展開/折りたたみ',
    hideSidebar: 'サイドバーを非表示',
    showSidebar: 'サイドバーを表示',
    switchToLightMode: 'ライトモードに切り替え',
    switchToDarkMode: 'ダークモードに切り替え',
    cinemaChainStatus: 'ステータス',
    deptStatus: 'ステータス',
    sort: '並び替え',
    filter: 'フィルター',
    displaySort: '表示順序',
    plsInputValidEmail: '正しいメールアドレスを入力してください',
    plsInputValidPhone: '正しい携帯番号を入力してください',
    code: 'コード',
    country: '国',
    upperLocation: '上位地域',
    invalidTime: '時間の形式が正しくありません',
    invalidTime2: '終了時間は開始時間よりも後の時刻に指定してください',
    close: '閉じる',
    cancelAccess: 'アクセスを取り消す',
    startDate: '開始日',
    endDate: '終了日',
    import: 'インポート',
    resetPWD: 'パスワードリセット',
    dragFile: 'ファイルをここにドラッグしてください',
    or: 'または',
    clickUpload: 'クリックしてアップロード',
    updateExistData: '既存のユーザーデータを更新しますか？',
    onlyImportFile: 'xls、xlsx形式のファイルのみインポート可能です',
    download: 'ダウンロード',
    downloadTemplate: 'テンプレートをダウンロードする',
    limitLength: '{min} から {max} の範囲内に指定してください。',
    invalidEmail: '無効なメールアドレス',
    invalidPhone: '無効な携帯電話番号',
    on: 'オン',
    off: 'オフ',
    confirmActiveUser: '{userName}のステータスを変更しますか？',
    confirmCancelAccess: 'そのユーザー{userName}の役割を取り消してもよろしいですか？',
    cancelSelectedAccess: '選択したユーザーの承認データ項目をキャンセルしますか？',
    plsInputNewPWD: '{userName}の新しいパスワードを入力してください',
    tips: '確認',
    userImport: 'ユーザーインポート',
    importResult: 'インポート結果',
    isLoading: '読み込み中...しばらくお待ちください',
    invalidNumber: '有効な番号に指定してください。',
    confirmLogout: 'ログアウトしてもよろしいですか?',
    personalInfomation: '個人情報',
    userName: 'ユーザー名',
    userMobile: '電話番号',
    userEmail: 'メールアドレス',
    departMent: '部署',
    role: '役割',
    createDate: '作成日',
    basicInformation: '基本情報',
    userNickName: 'ユーザーのニックネーム',
    gender: '性別',
    male: '男性',
    female: '女性',
    changePassword: 'パスワードを変更する',
    oldPassword: '以前のパスワード',
    newPassword: '新しいパスワード',
    confirmPassword: 'パスワード認証',
    save: '保存',
    themeStyleSetting: 'スタイル設定',
    themeColor: 'テーマカラー',
    systemLayoutConfig: 'レイアウト',
    trunon: '表示',
    fixed: '固定',
    show: '表示',
    recovery: '復元',
    dynamicTitle: 'ページタイトルに現在のセクション名をつける',
    saveSetting: '保存',
    resetSetting: 'リセット',
    system: 'システム',
    remerberPasword: 'パスワードを保存する',
    login: 'ログイン',
    register: '登録する',
    loginUsingExistingAccount: '既存のアカウントを使用してログインする',
    downloading: 'ダウンロード中...しばらくお待ちください',
    plsConfirmNewPassword: '新しいパスワードを確認してください',
    date: '日付',
    settingLayoutSize: '変更しています...しばらくお待ちください',
    invalidSession: 'セッションが無効であるか、セッションの有効期限が切れています。再度ログインしてください。',
    personalCenter: 'ユーザー設定',
    roleInformation: '役割情報',
    serialNumber: 'シリアルナンバー',
    roleNumber: 'ロール番号',
    permissionChar: 'ロールキー（システム用）',
    accessSuccess: '権限を付与しました',
    selectUser: 'ユーザーの選択',
    selectAssignUser: '割り当てるユーザーを選択してください',
    assingUser: 'ユーザーの割り当て',
    loginExpired: 'ログインセッションの有効期限が切れました。再度ログインしてください。',
    systemTips: '確認',
    loginRetry: '再ログイン',
    moreMenu: 'もっと',
  },
  user: {
    title: 'アカウント',
    name: 'ユーザー名',
    phone: '携帯電話番号',
    userId: 'ユーザーID',
    abbr: 'ユーザーのニックネーム',
    dept: '会社',
    belongDept: '所属会社',
    belongCinema: '所属劇場',
    email: 'メール',
    pwd: 'ユーザーパスワード',
    gender: 'ユーザー性別',
    position: '職位',
    role: '役割',
    remark: '備考',
    assignRole: '役割を割り当てる',
  },
  systemRole: {
    title: '権限グループ',
    name: '権限名',
    permissionChar: 'ロールキー（システム用）',
    permissionCharExample: '半角英数字（重複不可）',
    permissionRange: '権限範囲',
    roleId: '権限ID',
    roleSort: '順序',
    sort: '表示順序',
    menuPer: 'メニュー権限',
    dataper: '権限',
    checked: '全選択',
    parChild: '子権限を付与',
    assignUser: 'ユーザーを割り当てる',
    addUser: 'ユーザーを追加する',
    allCancelAccess: '一括承認キャンセル',
    allDataPer: 'すべての権限',
    cusDataPer: 'カスタム権限',
    deptDataPer: '部署権限',
    deptChildDataPer: '部署および以下のデータ権限',
    onlySelfDataPer: '自分のデータ権限のみ',
    confirmActiveRole: '{text}{roleName}役割を確認しますか？',
    assignDataPer: '権限を割り当てる',
  },
  system: {
    home: 'ホーム',
    title: 'CINEIGA',
    systemManage: {
      title: 'システム管理',
      menu: 'メニュー管理',
      position: 'ポジション管理',
      dict: '辞書管理',
      config: 'パラメータ設定',
      notice: 'お知らせ',
      log: {
        title: 'ログ管理',
        operLog: '操作ログ',
        logininfor: 'ログインログ',
      },
    },
    monitor: {
      online: 'オンラインユーザー',
      job: '定時ジョブ',
      druid: 'データ監視',
      server: 'サーバー監視',
      cache: 'キャッシュ監視',
      cacheList: 'キャッシュリスト',
    },
    tool: {
      title: 'システムツール',
      build: 'フォーム作成',
      gen: 'コード生成',
      swagger: 'システムインターフェース',
    },
  },
  // Movie
  movie: {
    id: 'ID',
    released: '500番台のみ',
    movieId: '作品コード',
    mwId: 'MW作品ID',
    eglId: 'EGL作品ID',
    title: '作品タイトル',
    isTitleConfirmed: '仮題フラグ',
    titleKana: 'タイトルカナ',
    titleKana8: 'かな8',
    aliases: '別名',
    originalTitle: '原題',
    englishTitle: '英題',
    osd: 'ODS',
    seriesId: 'シリーズ',
    seriesSequence: 'シリーズ順番',
    seriesGenreIds: 'シリーズジャンル',
    isJapaneseMovie: '洋画／邦画',
    duration: '上映時間',
    genreIds: 'ジャンル',
    highlightIds: '見どころ',
    category: '映倫',
    productionYear: '制作年',
    countryIds: '制作国',
    countriesNote: '制作国備考',
    companyIds: '配給会社',
    castRoles: 'キャスト',
    creditNote: 'クレジット備考',
    openDateType: '公開日',
    openDate: '公開日値',
    openSeasonYear: '年',
    openSeasonMonth: '月',
    openSeasonMonthPeriod: '旬',
    openSeasonMonthSolarTerm: '時季',
    openString: '公開日文字列',
    openConfirm: '公開日確定',
    copyright: 'コピーライト',
    catchphrase: 'キャッチコピー',
    commentary: '解説',
    story: 'あらすじ',
    officialPageUrl: '公式サイト',
    trailerYoutubeUrl: '予告編',
    officialXUrl: 'X ( 旧Twitter )',
    officialInstagramUrl: 'Instagram',
    officialFacebookUrl: 'Facebook',
    imdbUrl: 'IMDb',
    remark: '作品備考',
    posters: 'ポスター画像',
    screenshots: 'スチール写真',
    scheduleCount: '上映回数',
    scheduleCountIn10Days: '上映回数（最近の10日間）',
    headCinema: 'ヘッド館',
    headCinemaComment: 'ヘッド館コメント',
    movieStatus: 'ステータス',
    createTime: '作成日時',
    updateTime: '更新日時',
    delFlag: '削除フラグ',
    merge: 'マージを実行する',
    // 列表
    movieList: {
      search: 'タイトルで検索',
      sorting: 'ソート',
      genreIds: 'ジャンル',
      seriesId: 'シリーズ',
      sortType: '作成順',
    },
    // 详情
    movieDetail: {
      image: '画像',
      baseInfo: '基本情報',
      detailSet: '詳細設定',
      castSet: 'キャスト設定',
      moreInfo: '詳細情報',
      filmInfo: '作品情報',
      otherInfo: 'その他情報',
    },
    // 演员
    movieCharacter: {
      cast: '人名',
      role: '役割',
      roleName: '役名',
    },
    // merge log
    mergeLog: {
      targetMovieId: 'ターゲット作品ID',
      targetMovieName: 'ターゲット作品名',
      mergeMovie: 'ターゲットに統合する作品',
      actionTime: '実行時間',
      targetCastId: 'ターゲット人物ID',
      targetCastName: 'ターゲット人物',
      mergeCast: 'ターゲットに統合する人物',
    }
  },

  // 自定义像上传组件
  imageSortUpload: {
    title: '画像一覧',
    imageUpload: '画像をアップロードしてください',
    multiple: '※複数可能',
    icon: '画像選択',
    drop: 'ドラッグ&ドロップで',
    dropUpload: '画像をアップロード',
    sort: '表示順',
    preview: 'プレビュー',
    posters: 'ポスター画像',
    screenshots: 'スチール画像',
  },
  // Cinema
  cinema: {
    id: 'ID',
    cinemaId: '劇場ID',
    eglId: 'EGL劇場ID',
    name: '劇場名',
    nameKana: '劇場カナ',
    cinemaClassId: '劇場分類',
    sendSeatUrl: 'チケットリンク納品',
    cinemaChainId: '劇場系列',
    businessHours: '営業時間',
    noOfScreen: 'スクリーン数',
    noOfSeat: '座席数',
    screens: 'スクリーン',
    areaId: 'エリア',
    prefectureId: '都道府県',
    districtId: '地区',
    iAreaId: 'i-エリア',
    postcode: '郵便番号',
    districtNumber: '地区内連番',
    cityName: '市区町村',
    address1: '住所1',
    address2: '住所2',
    latitude: '緯度',
    longitude: '経度',
    latitude_jp_degree: '日本緯度（度）',
    latitude_jp_minute: '日本緯度（分）',
    latitude_jp_second: '日本緯度（秒）',
    longitude_jp_degree: '日本経度（度）',
    longitude_jp_minute: '日本経度（分）',
    longitude_jp_second: '日本経度（秒）',
    access: 'アクセス',
    accessDetail: 'アクセス詳細',
    phoneInfo: '電話情報',
    phoneNo: '電話番号',
    businessPhoneNo: '取材用電話',
    faxNo: 'FAX番号',
    inquiryInfo: '問い合わせ',
    haveParking: '駐車場有無',
    parking: '駐車場・台数',
    isParkingFree: '駐車場有料区分',
    wheelchairSeating: '車椅子席数',
    facilityIds: '設備',
    price: '料金',
    discount: '割引',
    twitterUrl: 'X (旧Twitter) URL',
    facebookUrl: 'Facebook URL',
    instagramUrl: 'Instagram URL',
    lineUrl: 'LINE URL',
    email: 'メールアドレス',
    hpUrl: '劇場URL',
    scheduleDataFrom: 'スケジュール取得方法',
    cpUuid: 'CP用UUID',
    cp2Uuid: 'CP2用UUID',
    scheduleCount: '上映回数',
    cinemaStatus: 'ステータス',
    statusNote: 'ステータス備考',
    note: '備考',
    userInCharge: '担当者',
    schedule: 'スケジュール',
    update: '再クローリング',
    crawlResult: 'クローリング結果',
    crawlOKdate: 'クローリングOK日時(前回)',
    scheuleLastDate: 'スケジュール最終日付',
    seriesWork: '500番台作品',
    recrawling: 'クローリングNGを一括再クローリング',
    mw: 'MW対象館',
    cinemaDetail: {
      baseInfo: '基本情報',
      detailSet: '詳細設定',
      castSet: 'スクリーン設定',
      otherInfo: 'その他情報',
      snsInfo: 'SNS情報',
      cinemaInfo: '劇場情報',
      contactInfo: '連絡情報',
      locationInfo: '位置情報',
    },
    hardCode: {
      title: '作品ハードコード',
      merge: '既存スケジュールデータを直す',
    },

    screen: {
      id: 'スクリーンID',
      name: '名前',
      numberOfSeats: '座席数',
      numberOfWheelChairSeats: '車椅子席数',
      screenFacilities: 'スクリーン設備',
      soundSystem: '音響設備',
    },
    // 详情
    movieDetail: {
      image: '画像',
      baseInfo: '基本情報',
      detailSet: '詳細設定',
      castSet: 'キャスト設定',
      moreInfo: '詳細情報',
      filmInfo: '作品情報',
      otherInfo: 'その他情報',
    },
    // 演员
    movieCharacter: {
      cast: '人名',
      role: '役割',
      roleName: '役名',
    },
    crewlingHardcodeMovie: {
      Type: 'タイプ',
      FromMovieNameCond: '完全一致/部分一致',
      FromMovieName: '作品名文字列',
      FromVersion: 'バージョンから',
      FromStartTime: '対象上映開始時間',
      FromStartDateFrom: '対象上映日付(開始)',
      FromStartDateTo: '対象上映日付(終了)',
      ToMovieId: 'target ID',
      ToVersion: '登録するバージョン',
      IsEnable: '有効',
      EnableFrom: '有効開始時間',
      EnableTo: '有効終了時間',
      Brand: '劇場系列/システムタイプ',
      CinemaId: '劇場ID',
      FromTime: '対象上映開始時間',
      Enable: '有効にする',
    },
  },
  // Company
  company: {
    id: '会社ID',
    search: {
      placeholder: '会社名で検索',
    },
    table: {
      name: '名前',
      abbreviation: '略称',
      jpCompanyName: '会社名カナ',
      telephoneNumber: '電話番号',
      companyType: '会社種類',
      createTime: '作成日時',
      updateTime: '更新日時',
    },
    dialog: {
      title: '会社編集',
    },
    parentId: '親会社',
  },
  cast: {
    title: '人物',
    id: 'キャストID',
    search: {
      name: '名前',
      originalName: '英語名／原語名',
      nameKana: '人名カナ',
      writtenName: '人名（誌面）',
      sex: '性別',
      birthPlace: '出身地',
      birth: '生年月日',
      mainRole: '主な役割',
      debut: 'デビュー作',
      profile: 'プロフィール',
      samePerson: '同一人物',
    },
  },
  // Country
  country: {
    title: '国',
    englishName: '英語名',
    japaneseName: '日本語名',
    abbr: '略称',
  },
  // HighLight
  highlight: {
    title: '見どころ',
    name: '名前',
  },
  // i-Area
  iArea: {
    name: 'i-エリア',
    nameKana: 'i-エリアカナ',
  },
  // MovieSeries
  movieSeries: {
    title: '作品シリーズ',
    search: {
      name: '名前',
      originalName: '英語名／原語名',
      nameKana: 'フリガナ',
      commentary: '解説',
    },
  },
  // Role
  role: {
    title: '役',
    roleList: {
      name: '名前',
      abbr: '略称',
    },
  },
  // Genre
  genre: {
    name: '作品ジャンル',
  },
  // Version
  version: {
    title: '上映会バージョン',
    name: '名前',
    version0: '2D/3D',
    version1: 'スクリーン規格',
    version1Tab: 'スクリーン規格',
    version2: '字幕/吹替',
    version3: 'その他バージョン',
  },
  // Facility
  facility: {
    title: '劇場施設',
    name: '名前',
  },
  // CinemaChain
  cinemaChain: {
    title: '劇場系列',
    name: '名前',
    code: 'ローマ字コード',
    total_no_of_cinemas: '総館数',
    total_no_of_screens: '総スクリーン数',
    total_no_of_seats: '総席数',
    membership: '会員制度',
    official_page_url: '公式サイト（URL）',
  },
  location: {
    title: '地区',
    locationSearch: '地区で検索',
    name: '名前',
    area: 'エリア',
    prefecture: '都道府県',
    district: '市区町村',
    sort: 'エリア内連番',
    districtSort: '都道府県内連番',
    nameKana: '市区町村カナ',
  },
  season: {
    search: 'シーズン名で検索',
    name: 'シーズン',
  },
  // SeriesGenre
  seriesGenre: {
    name: '作品シリーズジャンル',
  },
  // Cinema Class
  cinemaClass: {
    name: '劇場分類',
  },
  // Sound System
  soundSystem: {
    name: '音響',
  },
  // Merge movie
  mergeMovie: {
    name: 'マージ',
    mergeToTableName: 'ターゲットの作品',
    mergeFromTableName: 'ターゲットに統合する作品',
    title: '映画名',
    englishTitle: '英語名',
    productionYear: '制作年',
    openString: '公開日',
    countriesNote: '制作国備考',
    mergeHistory: 'マージ履歴',
  },
  // Merge cast
  mergeCast: {
    name: '人物マージ',
    mergeToTableName: 'ターゲットの人物',
    mergeFromTableName: 'ターゲットに統合する人物',
    targetDelete: 'ターゲットに統合する人物を削除',
    changeMovie: '変更になる作品',
    movieId: '作品ID',
    movieName: '作品名',
  },
  // Schedule
  schedule: {
    title: 'スケジュール',
    selectedDelete: '選択されたスケジュール一括削除',
    allDelete: '作品のスケジュール一括削除',
    plsEnter: '自由入力か絞り込みで選択してください',
    batchAdd: '時間未定で上映期間を登録する',
    search: {
      movieName: '上映作品名',
      cinemaName: '上映劇場名',
      cinemaChain: '上映劇場系列',
    },
    list: {
      id: 'スケジュールID',
      feature_id: '上映特集名',
      screen_id: '上映スクリーン',
      version1: 'スクリーン規格',
      version2: '字幕/吹替',
      version3: 'その他バージョン',
      version4: '上映区分',
      startTime: '上映開始時間',
      endTime: '終了時間',
      ticketingUrl: 'ネット予約URL',
      onlineSalesStartTtime: 'ネット予約開始時間',
      onlineSalesEndTime: 'ネット予約終了時間',
      ticketOfficeSalesStartTime: '販売開始時間（窓口）',
      ticketOfficeSalesEndTime: '販売終了時間（窓口）',
      dataFrom: 'スケジュール取得方法',
      time: '上映期間',
    },
    form: {
      basicInfo: '基本情報',
      cinema: '映画館',
      movieName: '作品',
      scheduleSeriesId: '上映特集',
      date: '上映日',
      screen: 'スクリーン',
      startTime: '上映時間',
      endTime: '上映終了',
      addRow: '上映時間を追加する',
      resetAll: '入力内容を全てリセット',
      submit: '入力内容をスケジュールとして追加する',
      commandInput: 'コマンド入力',
      uncheck: '時間未定',
    },
    fixFunction: 'スケジュール確定機能',
    Last_Fix_Action_Time: '最終確定させた時間',
    Last_Fix_Date: '最終確定させたスケジュールの日付け',
    Fix_Now: 'スケジュール確定させる',
  },
  // Schedule Series
  scheduleSeries: {
    search: '上映会特集名で検索',
    title: '上映会特集一覧',
    name: '名前',
    nameKana: 'フリガナ',
    startDate: '上映開始日付',
    note: '備考',
  },
  // Movie Hardcode
  movieHardCode: {
    newHardcodeMovie: '作品ハードコードの新規作成',
    type: 'タイプ',
    fromMovieNameCondition: '完全一致/部分一致',
    fromMovieName: '作品名文字列',
    fromVersion: 'バージョンから',
    fromStartTime: '対象上映開始時間',
    fromStartDateFrom: '対象上映日付(開始)',
    fromStartDateTo: '対象上映日付(終了)',
    toMovieId: '登録する作品ID',
    toVersion: '登録するバージョン',
    isEnable: '有効',
    enableFrom: '有効開始時間',
    enableTo: '有効終了時間',
    brand: '劇場系列/システムタイプ',
    cinemaId: '劇場ID',
  },
};
